import './skeleton.css';

const Skeleton = ({ toggle }) => {
    return (
        <section className={`skeleton-container flex`}>
            <section className={`skeleton-content flex flex-column w-100 br-5 ${toggle ? 'dark' : 'light'}`}>
                <section className='skeleton flag w-100 br-top-5'></section>
                <section className='skeleton skeleton-title skeleton-text'></section>
                <section className='skeleton skeleton-title skeleton-text'></section>
                <br />
                <section className='skeleton content skeleton-text'></section>
                <section className='skeleton content skeleton-text'></section>
                <section className='skeleton content skeleton-text'></section>
            </section>
            <section className={`skeleton-content flex flex-column w-100 br-5 ${toggle ? 'dark' : 'light'}`}>
                <section className='skeleton flag w-100 br-top-5'></section>
                <section className='skeleton skeleton-title skeleton-text'></section>
                <section className='skeleton skeleton-title skeleton-text'></section>
                <br />
                <section className='skeleton content skeleton-text'></section>
                <section className='skeleton content skeleton-text'></section>
                <section className='skeleton content skeleton-text'></section>
            </section>
            <section className={`skeleton-content flex flex-column w-100 br-5 ${toggle ? 'dark' : 'light'}`}>
                <section className='skeleton flag w-100 br-top-5'></section>
                <section className='skeleton skeleton-title skeleton-text'></section>
                <section className='skeleton skeleton-title skeleton-text'></section>
                <br />
                <section className='skeleton content skeleton-text'></section>
                <section className='skeleton content skeleton-text'></section>
                <section className='skeleton content skeleton-text'></section>
            </section>
            <section className={`skeleton-content flex flex-column w-100 br-5 ${toggle ? 'dark' : 'light'}`}>
                <section className='skeleton flag w-100 br-top-5'></section>
                <section className='skeleton skeleton-title skeleton-text'></section>
                <section className='skeleton skeleton-title skeleton-text'></section>
                <br />
                <section className='skeleton content skeleton-text'></section>
                <section className='skeleton content skeleton-text'></section>
                <section className='skeleton content skeleton-text'></section>
            </section>
            <section className={`skeleton-content flex flex-column w-100 br-5 ${toggle ? 'dark' : 'light'}`}>
                <section className='skeleton flag w-100 br-top-5'></section>
                <section className='skeleton skeleton-title skeleton-text'></section>
                <section className='skeleton skeleton-title skeleton-text'></section>
                <br />
                <section className='skeleton content skeleton-text'></section>
                <section className='skeleton content skeleton-text'></section>
                <section className='skeleton content skeleton-text'></section>
            </section>
            <section className={`skeleton-content flex flex-column w-100 br-5 ${toggle ? 'dark' : 'light'}`}>
                <section className='skeleton flag w-100 br-top-5'></section>
                <section className='skeleton skeleton-title skeleton-text'></section>
                <section className='skeleton skeleton-title skeleton-text'></section>
                <br />
                <section className='skeleton content skeleton-text'></section>
                <section className='skeleton content skeleton-text'></section>
                <section className='skeleton content skeleton-text'></section>
            </section>
            <section className={`skeleton-content flex flex-column w-100 br-5 ${toggle ? 'dark' : 'light'}`}>
                <section className='skeleton flag w-100 br-top-5'></section>
                <section className='skeleton skeleton-title skeleton-text'></section>
                <section className='skeleton skeleton-title skeleton-text'></section>
                <br />
                <section className='skeleton content skeleton-text'></section>
                <section className='skeleton content skeleton-text'></section>
                <section className='skeleton content skeleton-text'></section>
            </section>
            <section className={`skeleton-content flex flex-column w-100 br-5 ${toggle ? 'dark' : 'light'}`}>
                <section className='skeleton flag w-100 br-top-5'></section>
                <section className='skeleton skeleton-title skeleton-text'></section>
                <section className='skeleton skeleton-title skeleton-text'></section>
                <br />
                <section className='skeleton content skeleton-text'></section>
                <section className='skeleton content skeleton-text'></section>
                <section className='skeleton content skeleton-text'></section>
            </section>
            <section className={`skeleton-content flex flex-column w-100 br-5 ${toggle ? 'dark' : 'light'}`}>
                <section className='skeleton flag w-100 br-top-5'></section>
                <section className='skeleton skeleton-title skeleton-text'></section>
                <section className='skeleton skeleton-title skeleton-text'></section>
                <br />
                <section className='skeleton content skeleton-text'></section>
                <section className='skeleton content skeleton-text'></section>
                <section className='skeleton content skeleton-text'></section>
            </section>
            <section className={`skeleton-content flex flex-column w-100 br-5 ${toggle ? 'dark' : 'light'}`}>
                <section className='skeleton flag w-100 br-top-5'></section>
                <section className='skeleton skeleton-title skeleton-text'></section>
                <section className='skeleton skeleton-title skeleton-text'></section>
                <br />
                <section className='skeleton content skeleton-text'></section>
                <section className='skeleton content skeleton-text'></section>
                <section className='skeleton content skeleton-text'></section>
            </section>
            <section className={`skeleton-content flex flex-column w-100 br-5 ${toggle ? 'dark' : 'light'}`}>
                <section className='skeleton flag w-100 br-top-5'></section>
                <section className='skeleton skeleton-title skeleton-text'></section>
                <section className='skeleton skeleton-title skeleton-text'></section>
                <br />
                <section className='skeleton content skeleton-text'></section>
                <section className='skeleton content skeleton-text'></section>
                <section className='skeleton content skeleton-text'></section>
            </section>
            <section className={`skeleton-content flex flex-column w-100 br-5 ${toggle ? 'dark' : 'light'}`}>
                <section className='skeleton flag w-100 br-top-5'></section>
                <section className='skeleton skeleton-title skeleton-text'></section>
                <section className='skeleton skeleton-title skeleton-text'></section>
                <br />
                <section className='skeleton content skeleton-text'></section>
                <section className='skeleton content skeleton-text'></section>
                <section className='skeleton content skeleton-text'></section>
            </section>
            <section className={`skeleton-content flex flex-column w-100 br-5 ${toggle ? 'dark' : 'light'}`}>
                <section className='skeleton flag w-100 br-top-5'></section>
                <section className='skeleton skeleton-title skeleton-text'></section>
                <section className='skeleton skeleton-title skeleton-text'></section>
                <br />
                <section className='skeleton content skeleton-text'></section>
                <section className='skeleton content skeleton-text'></section>
                <section className='skeleton content skeleton-text'></section>
            </section>
            <section className={`skeleton-content flex flex-column w-100 br-5 ${toggle ? 'dark' : 'light'}`}>
                <section className='skeleton flag w-100 br-top-5'></section>
                <section className='skeleton skeleton-title skeleton-text'></section>
                <section className='skeleton skeleton-title skeleton-text'></section>
                <br />
                <section className='skeleton content skeleton-text'></section>
                <section className='skeleton content skeleton-text'></section>
                <section className='skeleton content skeleton-text'></section>
            </section>
            <section className={`skeleton-content flex flex-column w-100 br-5 ${toggle ? 'dark' : 'light'}`}>
                <section className='skeleton flag w-100 br-top-5'></section>
                <section className='skeleton skeleton-title skeleton-text'></section>
                <section className='skeleton skeleton-title skeleton-text'></section>
                <br />
                <section className='skeleton content skeleton-text'></section>
                <section className='skeleton content skeleton-text'></section>
                <section className='skeleton content skeleton-text'></section>
            </section>

        </section>
    )
}

export default Skeleton